function setDebug(working, args, p) {
  p.debug = true;
  return working.text;
}
setDebug.key = "set-debug";
setDebug.title = "Set Debug";
setDebug.category = "Flow Control";
setDebug.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/set-debug/";
setDebug.description =
  "Enable debug logging for the pipeline. Does not affect the working text.";
setDebug.args = [];
setDebug.passthrough = true;

export default setDebug;
